import React, { Component } from 'react';
import { AutoAffix } from 'react-overlays';
import classNames from 'classnames';

export class FilterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      affixedStyle: {},
    };
  }

  handleMobileToggle = (e) => {
    if (
      window.matchMedia(
        `only screen and (max-width: ${this.props.sizeForCollapse}px)`,
      ).matches
    ) {
      if (!this.state.expanded) {
        // if !expanded and mobile
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        this.setState({ expanded: true });
        document.body.style.overflow = 'hidden'; // disable body scroll
      } else {
        // if expanded and mobile
        this.setState({ expanded: false });
        document.body.style.overflow = null;
      }
    }
  };

  setAffixSize = () => {
    const el = this.refs.FILTER_CONTAINER_NAV;
    this.setState({
      affixedStyle: {
        minHeight: el.offsetHeight,
      },
    });
  };

  render() {
    const {
      props,
      state: { expanded, affixedStyle },
    } = this;

    const filterContainerNavProps = {
      ref: 'FILTER_CONTAINER_NAV',
      onClick: this.handleMobileToggle,
      className: classNames('FilterContainer--nav', {
        collapsed: !expanded,
        expanded: expanded,
      }),
    };

    return (
      <div className={classNames('FilterContainer--root', props.className)}>
        <div className="FilterContainer--navContainer" style={affixedStyle}>
          <AutoAffix affixClassName="affixed" onAffix={this.setAffixSize}>
            <div {...filterContainerNavProps}>
              <div className="clearfix" />

              <div className="FilterItemContainer">{props.children}</div>

              <div className="clearfix" />
            </div>
          </AutoAffix>
        </div>
        <div className="FilterContainer--contentContainer">{props.content}</div>
      </div>
    );
  }
}

FilterContainer.defaultProps = {
  sizeForCollapse: 967,
};
